import Style from "./style"

import PageTitle from "widget/PageTitle"
import Pagenation from "widget/Pagenation"

import useGetAccountSeedTicketRecord from "entity/account/useGetAccountSeedTicketRecord"

import { RECEIVE_BY_PRIZE, RECEIVE_DIRECT, convertRecordTypeAsName } from "shared/constant/lookup/recordType"
import timestampCalculator from "shared/lib/timestampCalculator"

const MySeedTicketRecord = () => {

    const [getSeedTicketRecord] = useGetAccountSeedTicketRecord()

    return (
        <Style.Wrapper>
            <PageTitle>내 시드권 사용 기록</PageTitle>

            <Style.RecordList>
                {getSeedTicketRecord?.data?.seed_ticket_record?.map(elem =>
                    <Style.RecordElement $increase={parseInt(elem?.change) > 0}>
                        <div>
                            <h2>{elem?.series_name}</h2>
                            <p>{elem?.ticket_name}</p>
                            {elem?.event_name && <p>{elem?.event_name}</p>}
                            <Style.RecordDiv $inc={[RECEIVE_BY_PRIZE, RECEIVE_DIRECT].includes(elem?.ticket_record_type_flag)}>
                                <h2>{convertRecordTypeAsName[elem?.ticket_record_type_flag]}</h2>
                                <p>{[RECEIVE_BY_PRIZE, RECEIVE_DIRECT].includes(elem?.ticket_record_type_flag) ? "+" : "-"}{elem?.number}</p>
                            </Style.RecordDiv>
                        </div>
                        <p>{timestampCalculator(elem?.created_at, "date")}</p>
                    </Style.RecordElement>
                )}
                {getSeedTicketRecord?.data?.seed_ticket_record?.length < 1 && <Style.Option>시드권 사용 기록이 없습니다.</Style.Option>}
            </Style.RecordList>

            <Pagenation maxPage={getSeedTicketRecord?.data?.max_page} />

        </Style.Wrapper>
    )
}

export default MySeedTicketRecord